<template>
  <ts-modal
    ref="modal"
    :keyboard="true"
    :modal-title="title"
    css-class="modal-alert"
  >
    <template #modal-content>
      <div class="modal-body">
        <div
          :class="['alert', `alert-${type}`, 'mb-0']"
          role="alert"
        >
          {{ message }}
        </div>
      </div>
    </template>
    <template #modal-footer>
      <button
        v-if="buttons.length == 0"
        class="btn btn-sm btn-secondary"
        data-bs-dismiss="modal"
        type="button"
      >
        {{ closeButtonTitle }}
      </button>
      <template v-else>
        <button
          v-for="(button, buttonIdx) of buttons"
          :key="buttonIdx"
          :class="['btn btn-sm', button.cssClass]"
          type="button"
          @click.prevent="$emit('modal-button-click', button)"
        >
          {{ button.title }}
        </button>
      </template>
    </template>
  </ts-modal>
</template>

<script lang="ts" setup>
import {ref, useTemplateRef} from 'vue'
import TsModal from './ts-modal.vue'

export interface ModalButton {
  title: string;
  cssClass: string;
  value: any;
}

defineProps({
  closeButtonTitle: {default: 'Close', type: String}
})

const modal = useTemplateRef<InstanceType<typeof TsModal>>('modal')

const title = ref<string>('')
const message = ref<string>('')
const type = ref<string>('')
const buttons = ref<ModalButton[]>([])

const show = (aTitle: string, aMessage: string, aType: string, aButtons?: ModalButton[]): void => {
  title.value = aTitle
  message.value = aMessage
  type.value = aType
  if (Array.isArray(aButtons)) {
    buttons.value = aButtons
  }

  modal.value?.show()
}

const hide = (): void => {
  modal.value?.hide()
}

defineExpose({
  hide,
  show,
})
</script>
